var map = {
	"./base.js": "VXDP",
	"./invita.js": "1RrC",
	"./magnet.js": "Lpt4",
	"./marbodal.js": "omQm",
	"./norema.js": "Go//",
	"./novart.js": "982x",
	"./sigdal.js": "q/MD"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "v+ZX";